import { Box, Typography, Button, Divider } from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import CheckinFormContent from "../CheckinFormContent";
import { formatDate } from "../CommonFunctions";
import { parseISO } from "date-fns";

const options = { weekday: "short", month: "short", day: "numeric", year: "numeric" };

export default function DocumentPreview({ data, onNext, onBack }) {
  let today = formatDate(new Date());
  today = parseISO(today).toLocaleDateString("en-us", options);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        height: "100%",
      }}
    >
      {/* Header Section */}
      <Box>
        <Typography variant="h5" gutterBottom>
          Document Preview
        </Typography>
        <Typography variant="body" color="text.secondary" mb={2}>
          Review and print guest information before proceeding.
        </Typography>
      </Box>

      {/* Scrollable Checkin Form Content */}
      <Box
        sx={{
          flex: 1,
          maxHeight: "50vh",
          overflowY: "auto",
          border: "1px solid #e0e0e0",
          borderRadius: 2,
          padding: 2,
          backgroundColor: "#fafafa",
          boxShadow: "inset 0 0 4px rgba(0,0,0,0.05)",
        }}
      >
        <CheckinFormContent
          value={{
            tenancyDetails: data?.tenancyDetails || {},
            customersDetails: data?.customersDetails || [],
          }}
          today={today}
        />
      </Box>

      <Divider sx={{ my: 1 }} />

      {/* Action Buttons */}
      <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
        <Button variant="outlined" onClick={onBack}>
          Back
        </Button>
        <Box>
          <Button
            variant="outlined"
            startIcon={<PrintIcon />}
            sx={{ mr: 2 }}
            onClick={() => window.print()}
          >
            Print
          </Button>
          <Button variant="contained" onClick={() => onNext({ docs: true })}>
            Proceed to Payment
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
